import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/documents/[documentId]/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/documents/$documentId",
)({
  component: Page,
});
